"use client";

import { useState } from "react";
import { Icon, Link, Text } from "@zapier/design-system";
import styles from "./SidebarMenu.module.css";
import classNames from "classnames";
import { ServiceRoute } from "src/utils/routes";

interface SidebarMenuProps {
  defaultOpen?: boolean;
  menu: ServiceRoute[];
  title: string;
}

export const SidebarMenu = ({ defaultOpen, menu, title }: SidebarMenuProps) => {
  const [open, setOpen] = useState(!!defaultOpen);

  return (
    <div>
      <div className={styles.title}>
        <button
          className={classNames(styles.iconWrapper, {
            [styles.open]: open,
            [styles.closed]: !open,
          })}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <Icon name="arrowSmallDown" size={24} />
        </button>
        <Text type="paragraph3Semibold">{title}</Text>
      </div>
      {open ? (
        <div>
          {menu.map((item) => (
            <div key={item.text} className={styles.menuItem}>
              <Link
                href={item.href}
                onClick={item.onClick}
                className={styles.styledLink}
              >
                <Text type="paragraph3" color="neutral700">
                  {item.text}
                </Text>
              </Link>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};
